import React from "react";
import { Modal, Button } from "react-bootstrap";

const Modal_Component = ({
  isOpen,
  handleClose,
  Submit_Function,
  Submit_Function_2,
  disabled_submit,
  Submit_Cancel_Function,
  cancel_btn,
  title,
  btn_name,
  btn_2,
  btn_name_2,
  backdrop,
  size,
  hideBtn,
  ...rest
}) => {
  return (
    <div>
      <Modal
        show={isOpen}
        centered
        size={size}
        backdrop={backdrop}
        onHide={handleClose}
        className={title === "Verify OTP" ? "otp-modal" : ""}
      >
        <Modal.Header
          closeButton
          className={`otp-modal-header${
            title === "Verify Your code"
              ? "border-0 flex-column align-items-start"
              : ""
          }`}
        >
          <h5 className="modal-title">{title}</h5>
          {title === "Verify Your code" && (
            <p className="text-muted mb-0 small">
              Enter the 4-digit verification code that was sent to your phone
              number.
            </p>
          )}
        </Modal.Header>

        <Modal.Body>{rest.children}</Modal.Body>
        <Modal.Footer
          className={`otp-modal-footer mb-4 ${
            title === "Verify OTP" ? "border-0" : ""
          }`}
        >
          {cancel_btn ? (
            <button
              type="submit"
              className="btn btn-danger "
              onClick={() => Submit_Cancel_Function()}
            >
              Cancel
            </button>
          ) : (
            ""
          )}

          {hideBtn === true ? (
            ""
          ) : (
            <Button
              form="otp-form"
              type="submit"
              className="btn btn-primary "
              disabled={disabled_submit}
              onClick={() => Submit_Function()}
            >
              {btn_name}
            </Button>
          )}

          {btn_2 === true ? (
            <Button
              form="otp-form"
              type="submit"
              className="btn btn-primary "
              disabled={disabled_submit}
              onClick={() => Submit_Function_2()}
            >
              {btn_name_2}
            </Button>
          ) : (
            ""
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Modal_Component;
